import "../css/users.css";

import React from "react";
import Breadcrumb from "../components/breadcrumb";
// import ModalForm from "../components/modalForm";
import ModalFormV2 from "../components/ModalFormV2";
import { Helmet, HelmetProvider } from 'react-helmet-async';

const CpaBlacklistConfig = () => {  

    let breadcrumbItens = [
        {
            text: "Home",
            route: "/"
        },
        {
            text: "CPA Blacklist",
            route: "#"
        }
    ];

    let inputs = [
        {              
            type: "select",
            name: "google_ads_account_id",
            id: "google_ads_account_id",
            label: "Conta Google Ads",
            isRequired: true,
            options: []
        },
        {
            type: "text",
            name: "campaign_id",
            label: "Campaign ID",
            isRequired: true
        },
        {
            type: "text",
            name: "campaign_name",
            label: "Nome da Campanha",
            isRequired: true
        },
        {
            type: "number",
            name: "min_impressions",
            label: "Mínimo de Impressões",
            isRequired: true
        },
        {
            type: "number",
            name: "min_conversions",
            label: "Mínimo de Conversões",
            isRequired: true
        },
        {
            type: "number",
            name: "max_cost_per_conversion",
            label: "Custo Máximo por Conversão",
            isRequired: true,
            step: "0.01"
        }
    ];

    let editInputs = [
        {              
            type: "select",
            name: "google_ads_account_id",
            id: "edit_google_ads_account_id",
            label: "Conta Google Ads",
            isRequired: true,
            options: []
        },
        {
            type: "text",
            name: "campaign_id",
            label: "Campaign ID",
            isRequired: true
        },
        {
            type: "text",
            name: "campaign_name",
            label: "Nome da Campanha",
            isRequired: true
        },
        {
            type: "number",
            name: "min_impressions",
            label: "Mínimo de Impressões",
            isRequired: true
        },
        {
            type: "number",
            name: "min_conversions",
            label: "Mínimo de Conversões",
            isRequired: true
        },
        {
            type: "number",
            name: "max_cost_per_conversion",
            label: "Custo Máximo por Conversão",
            isRequired: true,
            step: "0.01"
        },
        {
            type: "select",
            name: "status",
            id: "edit_status",
            label: "Status",
            isRequired: true,
            options: [
                {value: 1, text: "Ativo"},
                {value: 0, text: "Inativo"}
            ]
        }
    ];

    return (
        <div className="container">
            {/* <ModalForm input={inputs} action="save-cpa-config" elemId="cpaConfigModal" isEdit={false} title="Configuração CPA" /> */}
            {/* <ModalForm input={editInputs} action="update-cpa-config" elemId="editCpaConfigModal" isEdit={true} title="Configuração CPA" /> */}
            <ModalFormV2 input={inputs} action="save-cpa-config" elemId="cpaConfigModal" isEdit={false} title="Configuração CPA" />
            <ModalFormV2 input={editInputs} action="update-cpa-config" elemId="editCpaConfigModal" isEdit={true} title="Configuração CPA" />

            <div className="defaultContainer">
               
                <div className="row">
                    <div className="col-12">
                        <h1 className="h1">Configurações CPA Blacklist
                            <button 
                                type="button" 
                                className="btn btn-sm btn-add" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if(typeof window['openModal_cpaConfigModal'] === 'function') {
                                        window['openModal_cpaConfigModal']();
                                    }
                                }}
                            >
                                <span className="material-symbols-outlined transition">add_box</span>
                            </button>
                        </h1>
                        <Breadcrumb links={breadcrumbItens} />
                    </div>
                </div>
                <br />
                
                <div className="row">
                    <div className="col-12">
                        <table id="dtCpaConfigs" className="dataTables cell-border table table-bordered table-striped" style={{width:"100%"}}>
                            <thead>
                                <tr className="thead-dark">
                                    <th>Conta</th>
                                    <th>Campanha</th>
                                    <th>Campaign ID</th>
                                    <th>Min Impressões</th>
                                    <th>Min Conversões</th>
                                    <th>Max Custo/Conv</th>
                                    <th>Status</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody></tbody>
                            <tfoot></tfoot>
                        </table>    
                    </div>
                </div> 

            </div>
            <HelmetProvider>
                <Helmet>
                    <script src="./js/checkPermissions.js" type="text/javascript"></script>    
                    <script src="./js/datatables/cpa-blacklist-config.js" type="text/javascript"></script>
                </Helmet>
            </HelmetProvider> 
        </div>
    );
}

export default CpaBlacklistConfig;
